import Molde from "./MoldeTourTradicional";
import CardLugar from "../common/card/CardLugar";
import CardRecomienda from "../common/card/CardRecomienda";
import CardCaracteristica from "../common/card/CardCaracteristica";
import CardItinerario from "../common/card/CardItinerario";
import React from 'react';


export default function MarasMoray() {
  return (
    <>
      <Molde
        image={"/images/img-slide-desktop-moray.png"}
        title={"MARAS - MORAY"}
        subtitle={"(Medio Día)"}
        description={
          "Este recorrido presenta algunos de los sitios incas más interesantes de Cusco. El recorrido comienza con una visita al pueblo colonial de Maras y su iglesia. Desde Maras continuamos hacia el cercano sitio inca de Moray, una magnífica serie de terrazas circulares excavadas en el suelo que alguna vez fueron utilizadas por los incas para experimentar con cultivos. Nuestro destino final son las minas de sal que han estado en uso desde la época Pre-Inca. El agua de un arroyo subterráneo se canaliza a través de estanques donde se evapora y deja cristales de sal pura. Con miles de piscinas blancas que se extienden por el valle, las vistas son impresionantes."
        }
        linkForm={"/reservar/citytour-dia"}
        /*tipoprecio={"Precio por persona"}
        monto={"US$ 15.00"}
        moneda={"DOLARES"}*/
        picture1={            
          <>
          <div>
            <CardItinerario
              num="01"
              title="INICIO"
              lugar="MARAS"
              ></CardItinerario>

              <div className="pt-4 grid grid-cols-1 lg:grid-cols-3 p-2 lg:gap-4 gap-2 bg-primary-100">
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/maras_1.png`} alt="" />
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/maras_2.png`} alt="" />
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/maras_3.png`} alt="" />
              </div>
          </div>
          </>
        }

        picture2={            
          <>
          <div>
            <CardItinerario
              num="02"
              title="PARADA"
              lugar="MORAY"
              ></CardItinerario>
              <div className="pt-4 grid grid-cols-1 lg:grid-cols-3 p-2 lg:gap-4 gap-2 bg-primary-100">
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/moray_1.png`} alt="" />
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/moray_2.png`} alt="" />
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/moray_3.png`} alt="" />
              </div>
            </div>
          </>
        }

        picture3={            
          <>
          <div>
            <CardItinerario
              num="03"
              title="PARADA"
              lugar="SALINERAS"
              ></CardItinerario>
              <div className="pt-4 grid grid-cols-1 lg:grid-cols-3 p-2 lg:gap-4 gap-2 bg-primary-100">
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/salineras_1.png`} alt="" />
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/salineras_2.png`} alt="" />
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/salineras_3.png`} alt="" />
              </div>
            </div>
          </>
        }
        incluye={
          <>
            <p className="text-primary-800 font-light">Transporte turistico</p>
            
            <p className="text-primary-800 font-light">Asistencia permanente</p>
          </>
        }
        noIncluye={
          <>
            <p className="text-primary-800 font-light">Boleto turistico</p>
            <p className="text-primary-800 font-light">Ingreso a las salineras</p>
            <p className="text-primary-800 font-light">Gastos extra</p>
          </>
        }
        caracteristica={
            <>
              <CardCaracteristica
                icon={`${process.env.PUBLIC_URL}/icons/level.svg`}
                title={"Dificultad"}
                desc={"Facil"}
              />
              <CardCaracteristica
                icon={`${process.env.PUBLIC_URL}/icons/compartido.svg`}
                title={"Tipo Servicio"}
                desc={"Compartido"}
              />
              <CardCaracteristica
                icon={`${process.env.PUBLIC_URL}/icons/duracion.svg`}
                title={"Duración"}
                desc={"Full day"}
              />
              <CardCaracteristica
                icon={`${process.env.PUBLIC_URL}/icons/cultural.svg`}
                title={"Tipo de Tour"}
                desc={"Cultural - trek"}
              />
            </>
          }

        lugarvisita={
          <>
            <CardLugar
              icon={"01"}
              title={"Maras"}
            />
            <CardLugar
              icon={"02"}
              title={"Moray"}
            />
            <CardLugar
              icon={"03"}
              title={"Salineras"}
            />
            
          </>
        }
        TourRecomienda={
          <>
            <CardRecomienda
              img={"/images/montania_colores.png"}
              title={"MONTAÑA 7 COLORES"}
              puntuacion={"4.5"}
              link={'/tour-tradicional/montania-colores'}
            />
            <CardRecomienda
              img={"/images/valle-vip-5.png"}
              title={"VALLE VIP"}
              puntuacion={"5"}
              link={'/tour-tradicional/valle-vip'}
            />
            <CardRecomienda
              img={"/images/laguna_huamantay.png"}
              title={"LAGUNA HUAMANTAY"}
              puntuacion={"5"}
              link={'/tour-tradicional/laguna-huamantay'}
            />
            <CardRecomienda
              img={"/images/cris-1.png"}
              title={"CITY TOUR"}
              puntuacion={"4.5"}
              link={'/tour-tradicional/citytour'}
            />
          </>
        }
      />
    </>
  );
}
